(function(){
  var RV_NOTE='4,8/5', RV_COUNT='3 217 avis', RV_READ='Lire les avis';
  function css(){
    if(document.getElementById('so-rv-css'))return;
    var s=document.createElement('style');s.id='so-rv-css';
    s.textContent='.so-rv{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px 10px;margin:12px 0 10px;padding:11px 14px;border:1px solid #e8ebe6;border-radius:12px;background:#f7f9f5;text-decoration:none!important;font-family:Inter,-apple-system,sans-serif;font-size:14px;color:#4a4a4a}'+
      '.so-rv .s{color:#E8A33A;letter-spacing:2px;font-size:16px;line-height:1}.so-rv b{color:#2b2b2b}.so-rv .l{font-weight:700;color:#6f8f6a;text-decoration:underline;text-underline-offset:2px}.so-rv:hover{border-color:#6f8f6a}'+
      '.so-rv--cart{margin:0 0 10px;padding:9px 12px;font-size:13px}';
    document.head.appendChild(s);
  }
  function target(){
    var t=document.getElementById('so-avis'); if(t)return '#so-avis';
    var secs=document.querySelectorAll('#so section');
    for(var i=0;i<secs.length;i++){ if(/avis v[ée]rifi[ée]s/i.test(secs[i].textContent)){ secs[i].id=secs[i].id||'so-avis'; return '#'+secs[i].id; } }
    return '#so';
  }
  function mk(cls,closeFn){
    var a=document.createElement('a'); a.className=cls; a.href=target();
    a.innerHTML="<span class='s'>★★★★★</span><span><b>"+RV_NOTE+"</b> · "+RV_COUNT+"</span><span class='l'>"+RV_READ+" →</span>";
    if(closeFn)a.addEventListener('click',closeFn);
    return a;
  }
  function strip(){
    css();
    document.querySelectorAll('#so .cta-full').forEach(function(b){
      var n=b.nextElementSibling; if(n&&n.classList.contains('so-rv'))return;
      b.insertAdjacentElement('afterend',mk('so-rv'));
    });
  }
  function carts(){
    css();
    var soc=document.getElementById('soc');
    if(soc && !soc.querySelector('.so-rv--cart')){
      var co=soc.querySelector('.f .co');
      if(co) co.parentNode.insertBefore(mk('so-rv so-rv--cart',function(){var x=soc.querySelector('.x');if(x)x.click();}),co);
    }
    var mc=document.getElementById('minicart');
    if(mc){
      var rea=mc.querySelector('.mcrea');
      if(rea){ [].slice.call(rea.children).forEach(function(r){ if(/avis/i.test(r.textContent))r.remove(); }); }
      if(!mc.querySelector('.so-rv--cart')){
        var co2=[].slice.call(mc.querySelectorAll('a')).filter(function(e){return /^\s*Commander\s*$/i.test(e.textContent||'');})[0];
        var host=rea||co2;
        if(host) host.parentNode.insertBefore(mk('so-rv so-rv--cart',function(){var c=mc.querySelector('.mccont');if(c)c.click();}),host);
      }
    }
  }
  function run(){strip();carts();}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  try{new MutationObserver(carts).observe(document.documentElement,{childList:true,subtree:true});}catch(e){}
  setTimeout(run,800);
})();
